import * as H from 'history';
import { ISelectOption } from 'types';

import { EWalletNetwork, WalletNetworkMap } from 'modules/wallet';

export const goPDEditPage = (id: string | number | null, history: H.History<unknown>) => {
  if (id) {
    history.push(`/eecs-go/eecs-pds/edit/${id}?back_url=/eecs-go/eecs-inventory`);
  }
};

export const getProductionPeriodOptions = (year: string): ISelectOption[] => {
  return [
    {
      id: `${year}-01-01|${year}-03-31`,
      value: `${year}-01-01|${year}-03-31`,
      label: `Q1 ${year}`,
    },
    {
      id: `${year}-04-01|${year}-06-30`,
      value: `${year}-04-01|${year}-06-30`,
      label: `Q2 ${year}`,
    },
    {
      id: `${year}-07-01|${year}-09-30`,
      value: `${year}-07-01|${year}-09-30`,
      label: `Q3 ${year}`,
    },
    {
      id: `${year}-10-01|${year}-12-31`,
      value: `${year}-10-01|${year}-12-31`,
      label: `Q4 ${year}`,
    },
    {
      id: `${year}-01-01|${year}-06-30`,
      value: `${year}-01-01|${year}-06-30`,
      label: `H1 ${year}`,
    },
    {
      id: `${year}-07-01|${year}-12-31`,
      value: `${year}-07-01|${year}-12-31`,
      label: `H2 ${year}`,
    },
    {
      id: 'custom',
      value: 'custom',
      label: 'Custom',
    },
  ];
};

export const formatCurrency = (value: string | number, currency = ' €') => {
  const numericValue = Number(value);

  let [integerPart, decimalPart] = numericValue.toFixed(2).split('.');
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${integerPart}.${decimalPart}${currency}`;
};

export const formatGoUnit = (value: string | number, unit = ' MWh') => {
  const numericValue = Number(value);
  const split = numericValue.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${split}${unit}`;
};

export const formatNumber = (num: number, useFormat: boolean = true): string | number => {
  const absNum = Math.abs(num);
  let divisor = 1;
  let suffix = '';

  if (absNum >= 1e9) {
    divisor = 1e9;
    suffix = 'B';
  } else if (absNum >= 1e6) {
    divisor = 1e6;
    suffix = 'M';
  } else if (absNum >= 1e4) {
    divisor = 1e3;
    suffix = 'K';
  } else {
    return useFormat ? formatCurrency(num, '') : num;
  }

  const value = num / divisor;
  const roundedValue = Math.floor(value * 10) / 10;
  const hasDecimal = roundedValue % 1 !== 0;
  const formatted = hasDecimal ? roundedValue.toFixed(1) : roundedValue.toFixed(0);

  return `${formatted}${suffix}`;
};

export const walletTransactionExplorerHandler = (blockchain: EWalletNetwork | null, txnHash: string | null) => {
  if (!blockchain || !txnHash) return;
  const url = WalletNetworkMap[blockchain].explorerUrl + txnHash;
  window.open(url, '_blank');
};
